import React, { useState } from "react";

const Tooltip = ({ message, icon, className, icon2, withMargin = true }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const marginTopClass = icon2 ? "mt-0" : "mt-4";

  return (
    <div className="relative inline-block">
      <i
        className={`${icon ? icon : "fas fa-question-circle"} ${
          withMargin ? marginTopClass : "mt-0"
        } rounded ${className}`}
        onMouseEnter={toggleTooltip}
        onMouseLeave={toggleTooltip}
      ></i>
      {showTooltip && (
        <div className="w-96 text-sm z-40 absolute shadow-gray-500 bg-white text-stone-800 p-2 rounded-md shadow-md bottom-16 left-48 transform -translate-x-1/2">
          {message ? (
            message
          ) : (
            <>
              To assign a new head office, go to the profile page of the branch
              and click "Head Office" check box then save the changes.
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
